/**
 * Service module for the Leads entity
 * @module LeadService
 *
 * This module contains all requests regarding all actions of a Lead
 */
import { CrmAxios } from '@/config/axios';
/**
 * Returns the lead object
 * @param {string} receiverId Identifier of the Lead Receiver
 * @param {string} leadId Identifier of the Lead
 * @returns {Promise} Axios promise object represents the lead information
 */
export function getLead(receiverId, leadId) {
  return CrmAxios.get(`/receivers/${receiverId}/lead/${leadId}`);
}

export default {
  getLead,
};
